import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import './AccountInfoCard.scss'
import classnames from 'classnames'

export interface AccountInfoCardProps {
  accountName: string
  text?: string
  badgeTextColor?: string
  badgeColor?: string
  className?: string
  onClick?: () => void
  children?: React.ReactNode
}

export const AccountInfoCard: React.FC<AccountInfoCardProps> = ({ accountName, text, badgeColor, badgeTextColor, className, onClick, children }) => {
  return (
    <Card className={classnames(`account-user-card p-2 ${className || ''}`, { 'cursor-pointer': !!onClick })} onClick={onClick}>
      <Row className='align-items-center g-3'>
        <Col xs='auto'>
          <div className='user-badge d-flex align-items-center justify-content-center' style={badgeColor ? { backgroundColor: badgeColor } : {}}>
            <i className='bi bi-people-fill' style={badgeTextColor ? { color: badgeTextColor } : { color: 'white' }} />
          </div>
        </Col>

        <Col>
          <Row className='mb-0 pb-0'>
            <Col>
              <div className='paragraph-medium fw-bold'>{accountName}</div>
            </Col>
          </Row>
          {text ? (
            <Row>
              <Col>
                <div className='paragraph-small zocks-text-gray-600'>{text}</div>
              </Col>
            </Row>
          ) : null}
        </Col>

        {children && <Col xs='auto'>{children}</Col>}
      </Row>
    </Card>
  )
}
